import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './FormFieldValidationLabel.module.scss'

interface IFormFieldValidationLabelProps {
  text: string
  formKey: string
  fields: string[]
}

export const FormFieldValidationLabel: FC<IFormFieldValidationLabelProps> = ({
  text,
  formKey,
  fields,
}) => {
  const hasValidationError = useSelector((state: any) => {
    const invalidFields = state.form?.[formKey]?.invalidFields || {}

    return fields.some((field) => Boolean(invalidFields[field]))
  })

  return (
    <div className={styles.root}>
      <Translation text={text} />
      {hasValidationError && <span className={styles.asterisk}>*</span>}
    </div>
  )
}
